
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  handleMore() {
    window.open('https://mp.weixin.qq.com/s/gbgYUbhdn9dHeURg0C8o-g')
  }
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
